import { render, staticRenderFns } from "./loan-recovery.vue?vue&type=template&id=2d0fdf5a&"
import script from "./loan-recovery.vue?vue&type=script&lang=js&"
export * from "./loan-recovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports